import dayjs from 'dayjs';

import {
  OpenClass,
  OpenClassSession,
  OpenClassStatus,
} from '../types/OpenClass';

// Mirrors CalendarCourseInstanceInfo, one entry per day that has something on it.
export type OpenClassCalendarDay = {
  count: number;
  date: string;
};

const isRunning = (session: OpenClassSession) =>
  session.status !== OpenClassStatus.Canceled;

export const sessionDayKeys = (session: OpenClassSession): string[] => {
  const firstDay = dayjs(session.startAt).startOf('day');
  const ending = dayjs(session.endAt).subtract(1, 'millisecond').startOf('day');
  const lastDay = ending.isBefore(firstDay) ? firstDay : ending;

  const days: string[] = [];
  for (let day = firstDay; !day.isAfter(lastDay); day = day.add(1, 'day')) {
    days.push(day.format('YYYY-MM-DD'));
  }
  return days;
};

export const openClassCalendarDays = (
  openClasses: OpenClass[],
): OpenClassCalendarDay[] => {
  const classIdsByDay = new Map<string, Set<OpenClass['id']>>();

  openClasses.forEach((openClass) =>
    openClass.sessions.filter(isRunning).forEach((session) => {
      sessionDayKeys(session).forEach((key) => {
        const classIds = classIdsByDay.get(key) ?? new Set();
        classIds.add(openClass.id);
        classIdsByDay.set(key, classIds);
      });
    }),
  );

  return Array.from(classIdsByDay.entries())
    .map(([date, classIds]) => ({ count: classIds.size, date }))
    .sort((a, b) => a.date.localeCompare(b.date));
};

export const openClassesOnDate = (
  openClasses: OpenClass[],
  day: string,
): OpenClass[] =>
  openClasses.filter((openClass) =>
    openClass.sessions
      .filter(isRunning)
      .some((session) => sessionDayKeys(session).includes(day)),
  );
